<input
  [type]="to.type"
  [attr.required]="to.required"
  [attr.lang]="to.locale"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="op-input"
>